import type { PremiumStatus } from "../types";

/** Gem auto-craft: basic = any VIP subscription; full = VIP L4+ or VIP + Pro. */
export function gemAutoCraftEntitlements(premium: PremiumStatus | null | undefined) {
  const vip = premium?.vip;
  const subscriptionActive = vip?.subscription_active ?? false;
  const vipLevel = vip?.level ?? 0;
  const proActive = premium?.pro?.contract_active ?? false;
  return {
    basic: subscriptionActive,
    full: subscriptionActive && (vipLevel >= 4 || proActive),
  };
}

/** Auto astral gather: VIP L4+ with subscription, or active Pro. */
export function astralAutoGatherEntitlements(premium: PremiumStatus | null | undefined) {
  const vip = premium?.vip;
  const proActive = premium?.pro?.contract_active ?? false;
  if (proActive) return { unlocked: true };
  return {
    unlocked: (vip?.subscription_active ?? false) && (vip?.level ?? 0) >= 4,
  };
}
